// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yODo","footer":"styles_footer__2lZgG","passCodeTooltip":"styles_passCodeTooltip__34ZgX"};